export const createConversationChannelGroupString = (customerId, orgId) => {
  return `ext-convo-group-${orgId}.cust-${customerId}`;
};

export const createMetaCustomerChannelString = (customerId, orgId) => {
  return `ext-meta-cust-${orgId}.cust-${customerId}`;
};

export const createSharedCustomerChannelString = (customerId, orgId) => {
  return `shrd-cust-${orgId}.cust-${customerId}`;
};
